module.exports = __webpack_public_path__ + "static/media/004.05978895.jpg";